export const skillList = [
    {
        skillName: 'HTML',
        skillUrl: 'https://madhavbahl.tech/portfolio-assets/html.png',
    },
    {
        skillName: 'CSS',
        skillUrl: 'https://madhavbahl.tech/portfolio-assets/css.png',
    },
    {
        skillName: 'JavaScript',
        skillUrl: 'https://madhavbahl.tech/portfolio-assets/js.png',
    },
    {
        skillName: 'React',
        skillUrl: 'https://madhavbahl.tech/portfolio-assets/react.png',
    },
    {
        skillName: 'Redux',
        skillUrl: 'https://madhavbahl.tech/portfolio-assets/redux.png',
    },
    {
        skillName: 'NodeJS',
        skillUrl: 'https://madhavbahl.tech/portfolio-assets/node.png',
    },
    {
        skillName: 'TypeScript',
        skillUrl: 'https://madhavbahl.tech/portfolio-assets/ts.png',
    },
    // {
    //     skillName: 'Java',
    //     skillUrl: 'https://madhavbahl.tech/portfolio-assets/java.png',
    // },
    // {
    //     skillName: 'C#',
    //     skillUrl: 'https://madhavbahl.tech/portfolio-assets/cs.png',
    // },
    // {
    //     skillName: 'MongoDB',
    //     skillUrl: 'https://madhavbahl.tech/portfolio-assets/mongo.png',
    // },
];
